<template>
  <div class="relative w-full">
    <select
      :value="modelValue"
      @change="
        $emit('update:modelValue', $event.target.value);
        $emit('change', $event.target.value);
      "
      class="w-full bg-white dark:bg-dark-surface border border-slate-200 dark:border-white/5 rounded-xl px-4 py-2.5 text-sm font-bold text-slate-700 dark:text-slate-200 outline-none transition-all focus:ring-2 focus:ring-primary/20 focus:border-primary/50 appearance-none cursor-pointer hover:border-primary/30"
    >
      <slot></slot>
    </select>
    <div
      class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseSelect",
  props: {
    modelValue: [String, Number],
  },
  emits: ["update:modelValue", "change"],
};
</script>
